import React from "react";

/** The Exchange Alliance circular seal (public/brand). */
export const TeaLogo = ({ size = 40, className = "", testid = "tea-logo" }) => (
  <img src={size > 128 ? "/brand/tea-logo-512.png" : "/brand/tea-logo-128.png"} srcSet="/brand/tea-logo-128.png 1x, /brand/tea-logo-512.png 3x" alt="The Exchange Alliance" width={size} height={size}
    data-testid={testid} className={`shrink-0 rounded-full object-contain drop-shadow-[0_2px_8px_rgba(212,160,23,0.25)] ${className}`} style={{ width: size, height: size }} />
);
